import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import endpointList from "../../config/endpointList.jsx";
import image5 from "../../assets/backgroundImages/white.png";
import image3 from '../../assets/backgroundImages/map.png';
import image4 from '../../assets/backgroundImages/1.png';

// Thunk to fetch mockup categories
export const fetchMockupCategories = createAsyncThunk(
    'mockupCategories/fetchMockupCategories',
    async ({searchQuery=""}={}) => {
        const url = `${endpointList.getMockupCategories}?mockups=true&search=${searchQuery}`;
        console.log("Url",url)
        const response = await fetch(url);
        const data = await response.json();
        return data;
    }
); 

// Thunk to fetch mockups for a given category and page
export const fetchMockups = createAsyncThunk(
    'mockups/fetchMockups',
    async ({ page, categoryId,searchQuery }) => {
        const url = `${endpointList.getMockups}?page=${page}&category_id=${categoryId}&search=${searchQuery}`;
        const response = await fetch(url);
        const data = await response.json();
        return {
            categoryId,
            mockups: data.data,
            currentPage: data.current_page,
            lastPage: data.last_page,
            nextPageUrl: data.next_page_url,
            prevPageUrl: data.prev_page_url,
            total: data.total,
        };
    }
);

const initialState = {
    // We store categories in an array and initialize each category with empty pagination props.
    Mockups: [],
    selectedMockup: {
        design_layer: image4,
        glb_layer: image3,
        mask_layer: image5,
        shadow_layer: null,
        height: 500,
        width: 600,
        logoDefaultSize: 200,
        logoMinSize: null,
        logoMaxSize: null,
        logoBoundaryX1: null,
        logoBoundaryX2: null,
        logoBoundaryY1: null,
        logoBoundaryY2: null,
    },
    status: 'idle',
    error: null,
    isLoaded: false,
};

const mockupCategorySlice = createSlice({
    name: 'mockupCategories',
    initialState,
    reducers: {
        setSelectedMockup: (state, action) => {
            state.selectedMockup = action.payload;
        },
        clearSelectedMockup: (state) => {
            state.selectedMockup = {
                design_layer: null,
                glb_layer: null,
                mask_layer: null,
                shadow_layer: null,
                height: null,
                width: null,
                logoDefaultSize: null,
                logoMinSize: null,
                logoMaxSize: null,
                logoBoundaryX1: null,
                logoBoundaryX2: null,
                logoBoundaryY1: null,
                logoBoundaryY2: null,
            };
        },
    },
    extraReducers: (builder) => {
        builder
            // Handle fetchMockupCategories
            .addCase(fetchMockupCategories.pending, (state) => {
                state.status = 'loading';
                state.isLoaded = false;
            })
            .addCase(fetchMockupCategories.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.Mockups = action.payload.data;
                state.isLoaded = true;
            })
            .addCase(fetchMockupCategories.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
                state.isLoaded = false;
            })
            // Handle fetchMockups
            .addCase(fetchMockups.pending, (state) => {
                state.status = 'loading';
                state.isLoaded = false;
            })
            .addCase(fetchMockups.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const {
                    categoryId,
                    mockups,
                    currentPage,
                    lastPage,
                    nextPageUrl,
                    prevPageUrl,
                    total,
                } = action.payload;
                const existingCategory = state.Mockups.find(
                    (category) => category.id === categoryId
                );
                if (existingCategory) {
                    existingCategory.mockups = existingCategory.mockups.concat(mockups.data);
                    existingCategory.currentPage = currentPage;
                    existingCategory.lastPage = lastPage;
                    existingCategory.nextPageUrl = nextPageUrl;
                    existingCategory.prevPageUrl = prevPageUrl;
                    existingCategory.total = total;
                } else {
                    state.Mockups.push({
                        id: categoryId,
                        mockups,
                        currentPage,
                        lastPage,
                        nextPageUrl,
                        prevPageUrl,
                        total,
                    });
                }
                state.isLoaded = true;
            })
            .addCase(fetchMockups.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
                state.isLoaded = false;
            });
    },
});

export const { setSelectedMockup, clearSelectedMockup } = mockupCategorySlice.actions;
export default mockupCategorySlice.reducer;
